import { DefaultState } from '@src/redux/types'

import { RECRUITMENT_INQUIRY_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [RECRUITMENT_INQUIRY_LIST]: DefaultState<`${typeof API.RECRUITMENT_INQUIRY}`, 'get'>
} = () => ({
  [RECRUITMENT_INQUIRY_LIST]: defaultState(),
})
